<div class="not-found-container" (click)="redirect()">
  <div style="text-align: center; font-size: 1.8rem; margin-bottom: 15px">Esta página no existe</div>
  <img src="assets/images/404.svg" alt="Not Found" />
  <ion-button>Salir de aquí</ion-button>
</div>
